<template>
    <Transition name="pop">
        <div class="pop" v-if="show">
            <div class="content">
                <span class="close" @click="show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>我的奖品</h1>
                <ul>
                    <li v-for="(item, index) in rewards" :key="index">
                        <div class="img-wrapper">
                            <img :src="item.icon" alt="" />
                        </div>
                        <div class="info-wrapper">
                            <p>
                                <strong>奖品名称：</strong><br />{{ item.name }}
                            </p>
                            <p>
                                <strong>抽中日期：</strong><br />{{
                                    item.createtime
                                }}
                            </p>
                        </div>
                    </li>
                </ul>
                <div class="tips">
                    <div class="row">
                        <span>1、</span>
                        <p>
                            游戏道具请于新区开启后，前往在天风大陆新区福利
                            使者处领取。
                        </p>
                    </div>
                    <div class="row">
                        <span>2、</span>
                        <p>
                            点券及其他奖励将于活动结束后，统一将
                            兑奖券发放至满足要求的角色中。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref } from "vue";
import { GetMyRewards } from "@/api";
import REWARDS from "@/config/rewards";

const show = ref(false);
const rewards = ref([]);

// 获取我的奖励
const getMyRewards = async () => {
    const res = await GetMyRewards();
    if (res) {
        if (res.logs.length == 0) {
            return CsGame.alert("暂无奖励", 1600, "error");
        }
        rewards.value = res.logs.map((item) => {
            const { rewardid } = item;
            const find = REWARDS.find((item) => item.id == rewardid);
            if (find) {
                item = { ...item, ...find };
            }
            return item;
        });
    }
};

defineExpose({
    Show: async () => {
        await getMyRewards();
        show.value = true;
    }
});
</script>

<style lang="scss" scoped>
.pop {
    ul {
        padding: 0px 20px;
        max-height: 400px;
        overflow: auto;
        li {
            display: flex;
            margin-bottom: 10px;
            .img-wrapper {
                width: 180px;
                height: 120px;
                margin-right: 20px;
                background: linear-gradient(to bottom, #502416, #9e2d28);
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 100%;
                }
            }
            .info-wrapper {
                line-height: 1.4;
                p {
                    margin-bottom: 10px;
                }
                .btn-accept {
                    width: 100px;
                    height: 32px;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                    background-color: #9e2d28;
                    color: #f6c872;
                    margin-top: 20px;
                    border-radius: 3px;
                }
            }
        }
    }
    .tips {
        padding: 10px 20px;
        font-size: 14px;
    }
}
</style>
